import { render, staticRenderFns } from "./userFandomTable.vue?vue&type=template&id=7b6a127e&scoped=true&"
import script from "./userFandomTable.vue?vue&type=script&lang=js&"
export * from "./userFandomTable.vue?vue&type=script&lang=js&"
import style0 from "./userFandomTable.vue?vue&type=style&index=0&id=7b6a127e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6a127e",
  null
  
)

export default component.exports